import { useEffect } from 'react';
import { useAuthStore } from '@/stores/authStore';

/**
 * Which shop you are working in. Staff move between Dough & Soul and the
 * Breadbin, so sales, stock, shifts and cash-up all follow this rather than
 * the branch a person happens to be registered to.
 */
export default function BranchSelector({ compact = false }: { compact?: boolean }) {
  const { branches, activeBranchId, activeBranchName, setActiveBranch, loadBranches, staff } =
    useAuthStore();

  useEffect(() => {
    if (branches.length === 0) loadBranches();
  }, [branches.length, loadBranches]);

  const list = branches.length > 0
    ? branches
    : [{ id: activeBranchId, name: activeBranchName || staff?.branchName || 'Branch' }];

  const awayFromHome = !!staff && activeBranchId !== staff.branchId;

  return (
    <div className={compact ? 'flex items-center gap-1.5' : 'flex items-center gap-2'}>
      <select
        value={activeBranchId}
        onChange={(e) => {
          const b = list.find((x: any) => x.id === e.target.value);
          if (b) setActiveBranch(b.id, b.name);
        }}
        aria-label="Shop you are working in"
        className={
          compact
            ? 'text-xs font-semibold bg-white/15 text-white border border-white/30 rounded px-2 py-1 max-w-[150px]'
            : 'text-sm font-medium bg-white border border-gray-300 rounded-lg px-3 py-2 focus:ring-2 focus:ring-amber-500'
        }
      >
        {list.map((b: any) => (
          <option key={b.id} value={b.id} className="text-gray-900">
            {b.name}
          </option>
        ))}
      </select>
      {awayFromHome && (
        <span
          title={`Your home branch is ${staff?.branchName}`}
          className={
            compact
              ? 'text-[10px] font-bold text-amber-900 bg-amber-200 rounded px-1.5 py-0.5'
              : 'text-xs font-bold text-amber-800 bg-amber-100 rounded-full px-2 py-1'
          }
        >
          away
        </span>
      )}
    </div>
  );
}
